import { getRoleId } from "./session";

// Landing page per role: after login, for "/" and for "Go to your dashboard".
export const ROLE_HOME = {
  5: "/order-dashboard",
  8: "/order-dashboard",
  7: "/payment-dashboard",
  6: "/orders-table",
};

export function roleHome(roleId = getRoleId()) {
  return ROLE_HOME[Number(roleId)] || "/pages/login";
}

export default roleHome;
